import gql from 'graphql-tag'

export default gql`
  mutation RequestPasswordReset(
    $email: String!
  ) {
    requestPasswordReset(
      email: $email
    )
  }
`
